module.exports = __webpack_public_path__ + "static/img/1.f08b475.png";


//////////////////
// WEBPACK FOOTER
// ./static/ALL/1.png
// module id = jsFx
// module chunks = 202